// extracted by mini-css-extract-plugin
export default {"parserContentWrapper":"Parser_parserContentWrapper__cPdG4"};